module.exports = __webpack_public_path__ + "static/media/api-wild-dev.dbadba62.png";